import { Flex, Text } from "@chakra-ui/react";
import { formatMoney } from "infra/helpers/number";
import { ContaItemResponse } from "features/conta/typings";
import moment from "moment";
import colors from "resources/theme/colors";

interface StatusContentRighProps {
  item: ContaItemResponse;
}

export default function StatusContentRight({ item }: StatusContentRighProps) {
  const textStatus = item.dataPagamento
    ? "Pago"
    : moment(moment(item.dataVencimento).format("YYYY-MM-DD")).isBefore(
        moment().format("YYYY-MM-DD")
      )
    ? "Em Atraso"
    : "Em Aberto";
  const colorStatus = item.dataPagamento
    ? colors.accentPositive
    : moment(moment(item.dataVencimento).format("YYYY-MM-DD")).isBefore(
        moment().format("YYYY-MM-DD")
      )
    ? colors.accentNegative
    : colors.yellow500;
  return (
    <Flex mb={4} w="100%">
      <Flex
        flex={4}
        h="20px"
        w="2px"
        align="center"
        borderLeft={`solid 3px ${colorStatus}`}
        pl={1}
      >
        <Text>{textStatus}</Text>
      </Flex>
      <Flex fontSize="16px" fontWeight="bold">
        {formatMoney(item.valor)}
      </Flex>
    </Flex>
  );
}
